import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/DoctorTeachMainPage',
    name: 'DoctorTeachMainPage',
    component: () => import('../views/Doctor/DoctorTeachMainPage.vue')
  },
  {
    path: '/DoctorProduction',
    name: 'DoctorProduction',
    component: () => import('../views/Doctor/Production/DoctorProduction.vue')
  },
  {
    path: '/Invitation',
    name: 'Invitation',
    component: () => import('../views/Invitation/Invitation.vue')
  },
  {
    path: '/InvitationArticle',
    name: 'InvitationArticle',
    component: () => import('../views/Invitation/InvitationArticle.vue')
  }

  
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router